import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCampaignList } from "../action/CampaignAction";
import { Nav } from "react-bootstrap";

export default function Campaign({ clickFn, campaignRecords }) {
  return campaignRecords ? (
    campaignRecords.map((rec) => (
      <Nav.Item className={"NavBorder"} key={rec.Campaign_Id}>
        <Nav.Link onClick={(e) => clickFn(e, "campaignId", rec.Campaign_Id)}>
          {rec.Campaign_Name}
        </Nav.Link>
      </Nav.Item>
    ))
  ) : (
    <Nav.Item className="NavBorder">
      <Nav.Link eventKey="noRec">No Record Exist!</Nav.Link>
    </Nav.Item>
  );
}
